import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  CardActions,
  CardActionArea,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemLink,
  Grid,
  CardHeader,
  Chip,
  CardMedia,
  IconButton,
  Avatar, 
  Divider
} from '@material-ui/core';

import { LocationOn, Assignment, Group, FormatListNumbered } from '@material-ui/icons';



const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  content: {
    padding: 20
  },
  chip: {
    paddingBottom: 10,
    paddingTop: -10
  },
  green: {
    backgroundColor: 'primary',
    color: 'primary',
    justifyContent: 'flex-end'
  },
  image: {
    height: 48,
    width: 48
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const OfferDetails = props => {
  const { className, offer, ...rest } = props;

  // console.log(offer)

  const classes = useStyles();
  

  const checkDetails = (id) => {

  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        title={offer.title}
      />

      <Divider />

      <CardContent className={classes.content}>
    
        <Typography paragraph>
            {offer.description}        
        </Typography>

        <Divider variant="fullWidth" />
        <List>
        <ListItem>
        <ListItemAvatar>
          <Avatar>
            <LocationOn color="primary" />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={offer.location} secondary="Location" />
      </ListItem>
      <Divider />
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <Group color="primary"/>
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={offer.targeted_major} secondary="Targeted Major(s)" />
      </ListItem>
      <Divider />
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <FormatListNumbered color="primary" />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={offer.open_positions} secondary="Number of Positions" />
      </ListItem>
      <Divider />
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <Assignment color="primary"/>
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={offer.position} secondary="Position" />
      </ListItem>
      <Divider variant="fullWidth"/>
      </List>

      </CardContent>
 
    </Card>
  );
};

OfferDetails.propTypes = {
  className: PropTypes.string,
  offer: PropTypes.object.isRequired
};

export default OfferDetails;
